module.exports = __webpack_public_path__ + "img/kerlla.03972ad1.jpeg";